import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import Corehubsubtab from "./corehubsubtab";
import { getLearnerCourses } from "../../../Redux/CourseDetails";
import { getCoursesGroupedByCategoryAndModule } from "utils/foundationUnlock";
import useFetchImageUrls from "../../../ConstantUseFetchImageUrls";
import { coreHubAssets } from "../../../imagesData/ImagesData";

function Corehubtab({ hubName, hubDesc }) {
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const enterpriseId = activeAccount.idTokenClaims?.enterpriseID;
  const userLevelDes = activeAccount.idTokenClaims?.jobFamilyDescription;

  const { coursesByHub } = useSelector((state) => state.courseDetails);
  const userData = useSelector((state) => state.userDetails.userData[0]);

  const isEmpty = (value) =>
    value === null || value === undefined || value === "" || value === "NULL";
  const userLevel = isEmpty(userLevelDes) ? userData?.level : userLevelDes;
  const businessUnit = useMemo(
    () => userData?.businessUnit,
    [userData?.businessUnit],
  );

  const hubData = coursesByHub?.find((hub) => hub.hubName === hubName);
  const hubCourses = hubData?.courses || [];

  const query = `params=${encodeURIComponent(JSON.stringify(coreHubAssets))}`;
  const { imageUrls, error } = useFetchImageUrls(query);

  const urls = imageUrls?.imageUrl || {};

  useEffect(() => {
    if (!enterpriseId || !businessUnit) return;

    dispatch(getLearnerCourses(enterpriseId, businessUnit));
  }, [enterpriseId, businessUnit, dispatch]);

  const eligibleCoursesByCategoryAndModule = useMemo(() => {
    if (!hubCourses.length || !userData || !userLevel) return {};

    return getCoursesGroupedByCategoryAndModule({
      coursesByHub: [{ hubName, courses: hubCourses }],
      userData,
      userLevel,
      hubName,
    });
  }, [hubCourses, userData, userLevel, hubName]);

  let totalMandatory = 0;
  let completedMandatory = 0;

  Object.entries(eligibleCoursesByCategoryAndModule || {}).forEach(
    ([category, modules]) => {
      let categoryMandatory = 0;
      let categoryCompleted = 0;

      Object.values(modules).forEach((modCourses) => {
        const mandatoryCourses = modCourses.Mandatory || [];

        categoryMandatory += mandatoryCourses.length;

        categoryCompleted += mandatoryCourses.filter(
          (c) => c.enrollmentDate && c.completionDate,
        ).length;
      });

      totalMandatory += categoryMandatory;
      completedMandatory += categoryCompleted;
    },
  );

  const fullCourses = totalMandatory;
  const completedCourses = completedMandatory;

  const progressValue =
    fullCourses > 0 ? Math.round((completedCourses / fullCourses) * 100) : 0;

  const isGenAIHub = hubName === "GenAI and Agentic AI Hub";

  console.log(coursesByHub);

  if (error) return <div>Error loading assets</div>;
  if (!imageUrls || Object.keys(imageUrls).length === 0) return null;

  return (
    <>
      <div className="core-hub-section">
        <div className="core-hub-wrap">
          <div className="core-hub-row row1">
            <div className="core-hub-box">
              {isGenAIHub ? (
                <video
                  className="genai-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{
                    width: "100%",
                    height: "70%",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                  }}
                >
                  <source src={urls["genAiVideo"]} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <>
                  <img
                    src={urls["aboutThumbnail"]}
                    alt="about-thumbnail"
                    className="about-thumbnail"
                  />
                  <img
                    src={urls["playIcon"]}
                    alt="play"
                    className="Play-Visual"
                  />
                </>
              )}
            </div>
          </div>

          <div className="core-hub-row row2">
            <div className="core-hub-box">
              <h2 className="section-headings">
                {hubName === "Foundation" ? "Core Hub" : hubName}
              </h2>
              <h3>
                <span>
                  {completedCourses}/{fullCourses}{" "}
                </span>
                Courses completed{" "}
              </h3>
              {Object.entries(hubDesc).map(([key, value]) => (
                <p key={key}>{value}</p>
              ))}
            </div>

            <div className="progress-bar-box">
              <div className="progress-container">
                <div className="progress-header">
                  <span className="progress-label">Overall Progress</span>
                  <span className="progress-value">{progressValue}%</span>
                </div>

                <div className="progress-track">
                  <div
                    className="progress-fill"
                    style={{ width: `${progressValue}%` }}
                  />
                </div>

                <span className="progress-label">
                  This progress is calculated based only on your mandatory
                  courses.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="corehub-subtab-section">
        <Corehubsubtab hubName={hubName} />
      </div>
    </>
  );
}

export default Corehubtab;
